import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import card from './modules/card'
import cardProduct from './modules/cardProduct'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import UserStats from './modules/UserStats'
import dict from './modules/dict'



import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    card,
    cardProduct,
    tagsView,
    permission,
    settings,
    UserStats,
    dict,

  },
  getters
})

export default store
